module.exports = __webpack_public_path__ + "static/media/jth_favicon.cd60e701.ico";